import { useState } from 'react';
import { ApiError, api } from '../api/client';
import { Button, Field, Notice } from './ui';

/**
 * Your settings → Your password (2988): change it while signed in. Your current password first
 * (wrong guesses pause it like signing in); the new one follows the same rules as everywhere else.
 * It saves straight away, signs you out on every other device and stops any open reset link.
 */
export function PasswordSettings() {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  async function change() {
    setBusy(true);
    setError('');
    try {
      await api.changePassword(current, next);
      setDone(true);
      setOpen(false);
      setCurrent('');
      setNext('');
    } catch (err) {
      setError(err instanceof ApiError || err instanceof Error ? err.message : 'That didn’t change.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <fieldset className="plain-fieldset">
      <legend className="field-label">Your password</legend>
      {done && <Notice tone="ok">Your password is changed. You’re signed out on your other devices.</Notice>}
      {!open ? (
        <div>
          <Button
            size="small"
            icon="key"
            onClick={() => {
              setDone(false);
              setOpen(true);
            }}
          >
            Change your password
          </Button>
        </div>
      ) : (
        <div className="stack">
          <Field label="Current password" type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} data-autofocus />
          <Field
            label="New password"
            type="password"
            autoComplete="new-password"
            value={next}
            onChange={(e) => setNext(e.target.value)}
            hint="At least 10 characters, and not your email address. A short sentence works well. Changing it signs you out on your other devices."
          />
          {error && <Notice tone="crit">{error}</Notice>}
          <div className="row-actions">
            <Button
              variant="ghost"
              size="small"
              onClick={() => {
                setOpen(false);
                setError('');
                setCurrent('');
                setNext('');
              }}
            >
              Cancel
            </Button>
            <Button variant="primary" size="small" disabled={busy || !current || !next} onClick={() => void change()}>
              {busy ? 'Changing…' : 'Change password'}
            </Button>
          </div>
        </div>
      )}
    </fieldset>
  );
}
